// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1GbKG","additionalInfo":"AgreementModal_additionalInfo__2lO4u"};